import { render, staticRenderFns } from "./index.vue?vue&type=template&id=161e9f1d&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=161e9f1d&prod&lang=less&rel=stylesheet%2Fless&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "161e9f1d",
  null
  
)

export default component.exports